import { AlertTriangle } from "lucide-react";
const hrajbonusLogo = "/img/hrajbonus-logo.webp";
import gambleAwareLogo from "@assets/image_1773345679225.png";

const kasinaLinks = [
  { label: "Přehled kasin", href: "/kasina" },
  { label: "Porovnat kasina", href: "/porovnat" },
  { label: "Bonusy", href: "/bonusy" },
  { label: "Zahraniční kasina", href: "/kasina/zahranicni" },
  { label: "Mobilní kasina", href: "/kasina/mobilni" },
];

const automatyLinks = [
  { label: "Online automaty", href: "/automaty" },
  { label: "Jak vyhrát na automatech", href: "/automaty/jak-vyhrat" },
  { label: "Sloty které vyplácejí nejvíce", href: "/automaty/sloty-ktere-vyplaceji-nejvice" },
];

const pokerLinks = [
  { label: "Jak hrát", href: "/poker/jak-hrat" },
  { label: "Kombinace", href: "/poker/kombinace" },
  { label: "Strategie", href: "/poker/strategie" },
];

const aboutLinks = [
  { label: "Naši autoři", href: "/nasi-autori" },
  { label: "Redakční metodologie", href: "/redakcni-metodologie" },
  { label: "Kontakt", href: "/kontakt" },
  { label: "O nás", href: "/o-nas" },
];

const legalLinks = [
  { label: "Zásady cookies", href: "/zasady-cookies" },
  { label: "Ochrana osobních údajů", href: "/zasady-ochrany-osobnich-udaju" },
];

const reviewLinks = [
  { label: "OnlySpins",      href: "/kasina/onlyspins" },
  { label: "AllySpin",       href: "/kasina/allyspin" },
  { label: "Legiano",        href: "/kasina/legiano" },
  { label: "BassBet",        href: "/kasina/bassbet" },
  { label: "Fast Slots",     href: "/kasina/fastslots" },
  { label: "Spinanga",       href: "/kasina/spinanga" },
  { label: "Rabona",         href: "/kasina/rabona" },
  { label: "Casinia",        href: "/kasina/casinia" },
  { label: "Stone Vegas",    href: "/kasina/stone-vegas" },
  { label: "Golden Panda",   href: "/kasina/golden-panda" },
  { label: "Instant Casino", href: "/kasina/instant-casino" },
  { label: "BoaBoa",         href: "/kasina/boaboa" },
  { label: "Alf Casino",     href: "/kasina/alf-casino" },
  { label: "Cadoola",        href: "/kasina/cadoola" },
  { label: "Bankonbet",      href: "/kasina/bankonbet" },
  { label: "Wazamba",        href: "/kasina/wazamba" },
  { label: "SPINiT",         href: "/kasina/spinit" },
  { label: "SG Casino",      href: "/kasina/sg-casino" },
  { label: "Librabet",       href: "/kasina/librabet" },
  { label: "Nomini",         href: "/kasina/nomini" },
];

export function Footer() {
  return (
    <footer className="bg-[#001a4d] text-white" data-testid="footer">
      <div className="max-w-[1440px] mx-auto px-4 sm:px-6 lg:px-12 xl:px-16 py-12 lg:py-16">
        <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-5 gap-10 lg:gap-8 mb-12">
          <div className="md:col-span-2 lg:col-span-1">
            <div className="mb-5">
              <a href="/" data-testid="footer-logo-link">
                <img src={hrajbonusLogo} alt="HrajBonus" className="h-12 w-auto object-contain" width="192" height="48" />
              </a>
            </div>

            <p className="text-white/50 text-sm leading-relaxed mb-6">
              Hazardní hry jsou určeny pro zábavu, proto vždy zůstaňte ve svých mezích a sázejte jen tolik, kolik si můžete dovolit prohrát.
            </p>

            <div className="flex items-center gap-3">
              <span
                className="inline-flex items-center justify-center w-10 h-10 rounded-full bg-red-600 text-white text-xs font-bold border-2 border-red-500"
                data-testid="badge-18plus"
              >
                18+
              </span>
              <span
                className="inline-flex items-center px-3 py-1.5 rounded-full bg-white/10 text-white/70 text-xs font-medium border border-white/15"
                data-testid="badge-gamcare"
              >
                GamCare
              </span>
            </div>
          </div>

          <div>
            <p className="text-white font-semibold text-sm uppercase tracking-wider mb-4" data-testid="footer-heading-kasina">
              Kasina
            </p>
            <ul className="space-y-3">
              {kasinaLinks.map((link) => (
                <li key={link.label}>
                  <a
                    href={link.href}
                    className="text-white/50 text-sm hover:text-white transition-colors duration-200"
                    data-testid={`footer-link-kasina-${link.label.toLowerCase().replace(/\s/g, "-")}`}
                  >
                    {link.label}
                  </a>
                </li>
              ))}
            </ul>
          </div>

          <div>
            <p className="text-white font-semibold text-sm uppercase tracking-wider mb-4" data-testid="footer-heading-automaty">
              Automaty
            </p>
            <ul className="space-y-3">
              {automatyLinks.map((link) => (
                <li key={link.label}>
                  <a
                    href={link.href}
                    className="text-white/50 text-sm hover:text-white transition-colors duration-200"
                    data-testid={`footer-link-automaty-${link.label.toLowerCase().replace(/\s/g, "-")}`}
                  >
                    {link.label}
                  </a>
                </li>
              ))}
            </ul>
          </div>

          <div>
            <p className="text-white font-semibold text-sm uppercase tracking-wider mb-4" data-testid="footer-heading-poker">
              Poker
            </p>
            <ul className="space-y-3">
              {pokerLinks.map((link) => (
                <li key={link.label}>
                  <a
                    href={link.href}
                    className="text-white/50 text-sm hover:text-white transition-colors duration-200"
                    data-testid={`footer-link-poker-${link.label.toLowerCase().replace(/\s/g, "-")}`}
                  >
                    {link.label}
                  </a>
                </li>
              ))}
            </ul>
          </div>

          <div>
            <p className="text-white font-semibold text-sm uppercase tracking-wider mb-4" data-testid="footer-heading-about">
              O nás
            </p>
            <ul className="space-y-3">
              {aboutLinks.map((link) => (
                <li key={link.label}>
                  <a
                    href={link.href}
                    className="text-white/50 text-sm hover:text-white transition-colors duration-200"
                    data-testid={`footer-link-about-${link.label.toLowerCase().replace(/\s/g, "-")}`}
                  >
                    {link.label}
                  </a>
                </li>
              ))}
            </ul>
          </div>
        </div>

        {/* Casino reviews index — all 20 review pages linked from every page via the footer */}
        <div className="border-t border-white/10 pt-8 mb-10">
          <p className="text-white/40 text-xs uppercase tracking-wider font-semibold mb-4" data-testid="footer-heading-reviews">
            Recenze kasin
          </p>
          <ul className="flex flex-wrap gap-x-5 gap-y-2" data-testid="footer-review-links">
            {reviewLinks.map((link) => (
              <li key={link.href}>
                <a
                  href={link.href}
                  className="text-white/40 text-xs hover:text-white/70 transition-colors duration-200"
                  data-testid={`footer-review-${link.label.toLowerCase().replace(/\s/g, "-")}`}
                >
                  {link.label}
                </a>
              </li>
            ))}
          </ul>
        </div>

        <div className="p-5 rounded-xl border border-white/10 mb-10" style={{ background: "rgba(255,255,255,0.04)" }}>
          <p className="text-white/45 text-xs leading-relaxed" data-testid="text-affiliate-disclaimer">
            Některé odkazy na našem webu jsou affiliate odkazy – pokud vložíte peníze do kasina, můžeme obdržet provizi, to však neovlivňuje podmínky bonusů. Třetí strany si vyhrazují právo bonusy kdykoli změnit nebo zrušit. Před hraním si vždy prostudujte podmínky u každého kasina.
          </p>
        </div>

        <div className="border-t border-white/10 pt-6">
          <div className="flex flex-col sm:flex-row items-center justify-between gap-4">
            <p className="text-white/30 text-xs" data-testid="text-copyright">
              © 2026 hrajbonus.com · Hrajte zodpovědně
            </p>
            <div className="flex items-center gap-5">
              {legalLinks.map((link) => (
                <a
                  key={link.label}
                  href={link.href}
                  className="text-white/35 text-xs hover:text-white/60 transition-colors duration-200"
                  data-testid={`footer-legal-${link.label.toLowerCase().replace(/\s/g, "-")}`}
                >
                  {link.label}
                </a>
              ))}
            </div>
          </div>
        </div>
      </div>

      <div
        className="bg-[#00112e] border-t border-white/10 py-4"
        data-testid="responsible-gambling-bar"
      >
        <div className="max-w-[1440px] mx-auto px-4 sm:px-6 lg:px-12 xl:px-16">
          <div className="flex flex-col sm:flex-row items-center justify-center gap-4 sm:gap-8 text-center">
            <div className="flex items-center gap-2">
              <span className="inline-flex items-center justify-center w-7 h-7 rounded-full bg-red-600 text-white text-[10px] font-bold border border-red-500 flex-shrink-0">
                18+
              </span>
              <AlertTriangle className="w-4 h-4 text-yellow-400 flex-shrink-0" />
              <span className="text-white/70 text-xs font-semibold">
                Hrajte zodpovědně
              </span>
            </div>
            <div className="flex items-center gap-5">
              <a
                href="https://www.gambleaware.org/"
                target="_blank"
                rel="noopener noreferrer"
                className="opacity-70 hover:opacity-100 transition-opacity"
                data-testid="link-gambleaware-footer"
              >
                <img src={gambleAwareLogo} alt="GambleAware" className="h-6 w-auto object-contain" width="120" height="24" />
              </a>
              <a
                href="https://www.gamcare.org.uk"
                target="_blank"
                rel="noopener noreferrer"
                className="text-white/40 text-xs hover:text-white/70 transition-colors font-medium"
                data-testid="link-gamcare-footer"
              >
                GamCare
              </a>
              <a
                href="https://www.gamblingtherapy.org"
                target="_blank"
                rel="noopener noreferrer"
                className="text-white/40 text-xs hover:text-white/70 transition-colors font-medium"
                data-testid="link-gamblingtherapy-footer"
              >
                Gambling Therapy
              </a>
            </div>
          </div>
        </div>
      </div>
    </footer>
  );
}
